const viewTypes = Object.freeze({
  ALL: 'ALL',
  RFP: 'RFP',
  MANAGED_COMPANY_VIEW: 'MANAGED_COMPANY_VIEW',
});

export default viewTypes;
